import React from 'react';

import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

// NOTE: CRA 환경에 맞게 수정한 Sonner 컴포넌트
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        style: {
          borderRadius: '0.5rem',
        },
        // index.css 에 정의된 클래스 이름을 사용
        classNames: {
          default: 'default-toast',
          success: 'success-toast',
          error: 'error-toast',
          warning: 'warning-toast',
          info: 'info-toast',
        },
      }}
      style={
        {
          '--border-radius': '0.5rem',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
